/**
 * Deriva as iniciais de uma organização a partir do seu nome, para usar como
 * fallback visual quando ainda não há logo carregado.
 *
 * Regra: remove pontuação → divide por espaços → 1ª letra das 2 primeiras
 * palavras (ou as 2 primeiras letras se só houver uma). Uppercase.
 * Fallback "OS" quando o nome é vazio/indefinido.
 */
export function getOrgInitials(nome?: string | null): string {
  if (!nome) return 'OS';
  // Mantém letras (incl. acentuadas), dígitos e espaços; remove o resto.
  const limpo = nome.replace(/[^\p{L}\p{N}\s]/gu, ' ').trim();
  if (!limpo) return 'OS';

  const tokens = limpo.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return 'OS';

  const iniciais =
    tokens.length === 1
      ? tokens[0].slice(0, 2)
      : tokens[0][0] + tokens[1][0];

  return iniciais.toUpperCase();
}
